import { render, staticRenderFns } from "./KeyCase.vue?vue&type=template&id=5db0c868&scoped=true&"
var script = {}
import style0 from "./KeyCase.vue?vue&type=style&index=0&id=5db0c868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0c868",
  null
  
)

export default component.exports